import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';

import { safeStorageGet, safeStorageSet } from '~utils/safe-storage';

export type LocalStorageKeys = 'suggestions';
export const LOCAL_STORAGE_KEYS: Record<LocalStorageKeys, LocalStorageKeys> = {
  suggestions: 'suggestions',
} as const;

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  getItem<T>(key: LocalStorageKeys): T | null {
    const raw = safeStorageGet(key);

    if (raw === null) {
      return null;
    }

    try {
      return JSON.parse(raw) as T;
    } catch {
      Sentry.addBreadcrumb({
        category: 'local-storage',
        message: `getItem: failed to parse JSON for key "${key}"`,
        level: 'warning',
      });

      return null;
    }
  }

  setItem<T>(key: LocalStorageKeys, value: T): void {
    try {
      const jsonValue = JSON.stringify(value);
      const success = safeStorageSet(key, jsonValue);

      if (!success) {
        Sentry.addBreadcrumb({
          category: 'local-storage',
          message: `setItem: storage unavailable for key "${key}"`,
          level: 'warning',
        });
      }
    } catch {
      Sentry.addBreadcrumb({
        category: 'local-storage',
        message: `setItem: failed to serialize value for key "${key}"`,
        level: 'warning',
      });
    }
  }
}
